// Thin wrapper around gtag.js so the rest of the app never has to guard
// against analytics being unconfigured. Safe no-op until a real GA4
// measurement ID is added in public/index.html.
export function trackEvent(action, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", action, params);
  }
}
